/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/common-utils';
import { Link } from '@zapier/design-system';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { EVENT_TEAMS_DOWNGRADED_BANNER } from '@zapier/design-system-revenue/src/constants';

const rootStyles = css`
  a {
    text-decoration: underline;
  }
`;

export const TeamsDowngradedBanner = () => {
  const { trackEvent } = useTrackingContext();

  return (
    <div css={rootStyles}>
      You’re not on a team account anymore, so some features are no longer
      available.{' '}
      <Link
        color="white"
        href="/app/billing/plans/upgrade-to-team"
        onClick={() => trackEvent(EVENT_TEAMS_DOWNGRADED_BANNER)}
      >
        Upgrade
      </Link>{' '}
      or{' '}
      <Link
        color="white"
        href="/help/account/teams/cancel-your-zapier-for-teams-plan"
      >
        learn more
      </Link>
      .
    </div>
  );
};
